<div
  class="__post-media"
  [class.--is-desktop]="isDesktop"
>

  <!-- SINGLE -->
  <mip-single-theme
    *ngIf="forceTheme ? forceTheme === 'single' : postModel.theme === 'single'"
    [postModel]="postModel"
    [isModal]="isModal"
    [showInteraction]="showInteraction"
    [enableDetailsLink]="enableDetailsLink"
    [showHeader]="showHeader"
    [videoControlsPosition]="videoControlsPosition"
    [isIntoViewport]="isIntoViewport"
    [isIntoTopBounceLimit]="isIntoTopBounceLimit"
    [postVideoAdType]="postVideoAdType"
    [isPostRollAdEnable]="isPostRollAdEnable"
    [isPreRollAdEnable]="isPreRollAdEnable"
    [isAdEnable]="isAdEnable"
    [swiperNavigation]="swiperNavigation"
    [isFirstSlide]="isFirstSlide"
    [isLastSlide]="isLastSlide"
    [isMobile]="isMobile"
    [isDesktop]="isDesktop"
    [looping]="looping"
    (onPostHeaderToggle)="_onPostHeaderToggle($event)"
    (onToggleComments)="_onToggleComments()"
    (onToggleShare)="_onToggleShare()"
    (onVideoEnded)="_onVideoEnded()"
    (onPostAdFill)="_onPostAdFill($event)"
    (onPostAdHide)="_onPostAdHide($event)"
    (onPostAdPlayed)="_onPostAdPlayed()"
    (onPostAdEnded)="_onPostAdEnded()"
  ></mip-single-theme>

  <!-- STATIC -->
  <mip-static-theme
    *ngIf="forceTheme ? forceTheme === 'static' : postModel.theme === 'static'"
    [postModel]="postModel"
    [isIntoViewport]="isIntoViewport"
    [postBasePath]="postBasePath"
  ></mip-static-theme>

  <video
    #videoPreload
    class="__video-preload-element"
    preload="auto"
  ></video>

</div>

